export type TileFetchError = Error & { statusCode?: number };

export const TILE_EMPTY_STATUS_CODE = 204;

export function createTileFetchError(message: string, statusCode?: number): TileFetchError {
  const err = new Error(message) as TileFetchError;
  err.statusCode = statusCode;
  return err;
}

export function getTileFetchStatusCode(err: unknown): number | undefined {
  if (typeof err !== 'object' || err === null) {
    return undefined;
  }
  if (!('statusCode' in err)) {
    return undefined;
  }
  const code = (err as TileFetchError).statusCode;
  return typeof code === 'number' ? code : undefined;
}

export function isTileEmptyStatus(statusCode?: number | null): boolean {
  return statusCode === TILE_EMPTY_STATUS_CODE;
}
